<template>
  <v-card
    class="banner__info-prod"
    :class="!isMobileBreakpoint ? 'mx-6' : ''"
    :style="
      isBannerModal
        ? 'width: 100%; margin-top: 0;'
        : isMobileBreakpoint
        ? ''
        : 'margin-top: .5rem'
    "
    flat
  >
    <div class="d-flex container__title__info-prod align-start align-md-center">
      <div
        class="infoProductorPanda mr-4 py-2 px-4 mb-4 mb-md-0 rounded-lg d-flex d-flex-row align-start align-md-center"
      >
        <span class="text-no-wrap">{{
          $i18next.t('message.banners.infoProductorDay.tag')
        }}</span>
      </div>
      <div class="content-md-wrapper d-flex flex-md-row flex-column">
        <div class="d-flex flex-column mr-md-9">
          <span class="banner-title__info-prod">
            {{ $i18next.t('message.banners.infoProductorDay.title') }}
          </span>
          <span class="subtitle__info-prod white--text font-weight-regular">
            {{ $i18next.t('message.banners.infoProductorDay.subtitle') }}
          </span>
        </div>
        <div class="d-flex align-center align-xl-end">
          <div class="mb-md-1 mt-md-0 mt-2">
            <BaseBtn
              v-if="!isBannerModal"
              type="tertiary"
              @click="openCreditsModal"
              class="bg-dark--ignore text-no-wrap"
            >
              {{ $i18next.t('message.banners.infoProductorDay.action') }}
            </BaseBtn>
            <BaseBtn
              v-else
              type="tertiary"
              @click="openHelpDesk"
              class="bg-dark--ignore text-no-wrap"
            >
              {{ $i18next.t('message.banners.infoProductorDay.knowMore') }}
            </BaseBtn>
          </div>
        </div>
      </div>
    </div>
    <div class="close-banner__info-prod" v-if="!isBannerModal">
      <v-icon color="white" size="20px" @click="handleClose">mdi-close</v-icon>
    </div>
  </v-card>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue'
import Storage from '@/utils/Storage'
import linkHelper from '@/utils/linkHelper.mixin.js'
import { mapState } from 'vuex'

export default {
  name: 'InfoProductorBanner',
  components: { BaseBtn },
  mixins: [linkHelper],
  props: {
    isBannerModal: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
    ...mapState('user', {
      isTabletBreakpoint: 'isTabletBreakpoint',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
  },
  mounted() {
    const banner = document.querySelector('.banner__info-prod')
    banner.addEventListener('click', (e) => {
      const isCloseBtn = e.target.classList.contains('mdi-close')
      if (!isCloseBtn) this.openCreditsModal()
    })
  },
  methods: {
    openHelpDesk() {
      const link = this.getCreditsInDouble()
      window.open(link, '_blank')
    },
    openCreditsModal() {
      this.$root.$emit('creditsBuyModal')
    },
    handleClose() {
      const expiryDate = new Date()
      expiryDate.setDate(expiryDate.getDate() + 7)
      Storage.setItem('hasClosedInfoBanner', true)
      Storage.setItem('InfoproductorExpiry', expiryDate.toISOString())
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.infoProductorPanda {
  background-color: $color-brand;
  border: 2px solid $brand-70-light;
  height: 40px;
  -webkit-box-shadow: 0px 0px 20px -6px rgba(255, 255, 255, 0.63);
  -moz-box-shadow: 0px 0px 20px -6px rgba(255, 255, 255, 0.63);
  box-shadow: 0px 0px 20px -6px rgba(255, 255, 255, 0.63);

  span {
    color: $color-neutral-white;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
}
.close-banner__info-prod {
  position: absolute;
  right: 8px;
  top: 4px;
}

.container__title__info-prod {
  justify-content: center;
  align-items: center;
  width: 100%;
}

.content-wrapper__info-prod {
  display: flex;
  align-items: center;
  gap: 13vw;
}
.banner__info-prod {
  min-height: 94px;
  height: 94px;
  border-radius: 4px;
  background: linear-gradient(263deg, #425af0 22.15%, #182996 90.09%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px;
  cursor: pointer;

  .base-button--tertiary {
    color: $color-brand;
    background-color: #ffffff;
    border: 2px solid #ffff;
  }
}

.mirror {
  -webkit-transform: scaleX(-1) scaleY(-1);
  transform: scaleX(-1) scaleY(-1);
}

.banner-title__info-prod {
  color: #fff;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}

.subtitle__info-prod {
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.page-view {
  &__container.has-pre-content {
    grid-template-areas: 'header-mobile' 'pre-content' 'content' 'header' !important;
    grid-template-rows: auto auto 1fr auto !important;

    @media (min-width: 680px) {
      grid-template-areas: 'header' 'pre-content' 'content' !important;
      grid-template-rows: auto auto 1fr !important;
    }
  }
}

@media screen and (max-width: 1100px) {
  .banner__info-prod {
    justify-content: center;
  }
}

@media screen and (max-width: 982px) {
  .container__title__info-prod {
    flex-direction: column;
  }

  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: 75px auto calc(100vh - 249px) !important;
  }

  .banner__info-prod {
    margin-top: 50px;
    height: unset;
  }
}

@media screen and (max-width: 679px) {
  .page-view__container.c.has-pre-content,
  .page-view__container.ac.has-pre-content {
    grid-template-rows: auto auto 1fr auto !important;
  }
}

@media screen and (max-width: 572px) {
  .banner__info-prod {
    padding: 20px 20px;
    margin-top: 20px;
  }
}
</style>
